// /src/pdf/builders/tlh/buildDoc.js
const stripCalendar = (text) => (text || "").replace(/^📅\s*/u, "").trimStart();

export function buildTlhDoc({
  t,
  shortcode,
  stationName,
  serviceName,
  period,
  date1,
  tlh,
  start,
  end,
  totalSessions,
  fmtNumber,
  locale,
  logoDataUrl,
  chartDataUrl,
}) {
  const content = [];
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('tlh.title')) || 'TLH (Total Listening Hours)';
  const madeOn = (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net';

  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  const periodLabel = period === 'day'
    ? `${stripCalendar(t('tsl.date_label_day'))} ${date1 || ''}`
    : `${stripCalendar(t('tsl.date_label_last'))} ${date1 || ''}`;

  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    { margin: [0, 0, 0, 6], fontSize: 10, color: '#666', text: periodLabel.trim() },
    { text: madeOn, fontSize: 10, color: '#666', margin: [0, 0, 0, 10] }
  );

  if (chartDataUrl) {
    content.push({
      image: chartDataUrl,
      width: 520,
      margin: [0, 0, 0, 10]
    });
  }

  if (totalSessions > 0) {
    const infoStack = [];
    const fmt = (value) => (typeof fmtNumber === 'function' ? fmtNumber(value ?? 0, locale) : (value ?? 0));

    infoStack.push({
      text: `${(t && t('tlh.total_prefix')) || 'TLH:'} ${fmt(tlh)} ${(t && t('tlh.hours')) || 'hours'}`,
      bold: true
    });

    if (stationTitle) {
      infoStack.push({
        text: `${(t && t('tlh.station_prefix')) || 'Station:'} ${stationTitle}`
      });
    }

    if (start && end) {
      infoStack.push({
        text: `${(t && t('tlh.period_prefix')) || 'Period:'} ${start} — ${end}`
      });
    }

    infoStack.push({
      text: `${(t && t('tlh.sessions_prefix')) || 'Sessions:'} ${fmt(totalSessions)}`
    });

    content.push({
      margin: [0, 4, 0, 0],
      stack: infoStack,
      fontSize: 10.5
    });
  } else {
    content.push({
      text: (t && t('tlh.no_data')) || 'No data for this period',
      fontSize: 11,
      bold: true
    });
  }

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: madeOn, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
    },
  };
}

export { buildTlhDoc as default };
